import {
  contenItems,
  contenAdd,
  contentDel,
  tandeAuditItemsAll,
  tandeAuditDetails,
  tandeAuditEmpTandEItems,
  itemsGroupEmp,
  groupUserItems,
  changeAuditAuth,
  deleteAuditAuth,
  createAuditAuth,
  throughA,
  throughB,
  refusedA,
  refusedB
} from '@/api/tandeAudit'

const tandeAudit = {
  state: {

  },
  mutations: {

  },
  actions: {
    ContentDel ({ commit }, data) {
      return new Promise((resolve, reject) => {
        contentDel(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ContenAdd ({ commit }, data) {
      return new Promise((resolve, reject) => {
        contenAdd(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ContenItems ({ commit }) {
      return new Promise((resolve, reject) => {
        contenItems().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditItemsAll ({ commit }, data) {
      return new Promise((resolve, reject) => {
        tandeAuditItemsAll(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditDetails ({ commit }, data) {
      return new Promise((resolve, reject) => {
        tandeAuditDetails(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditEmpTandEItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        tandeAuditEmpTandEItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditItemsGroupEmp ({ commit }) {
      return new Promise((resolve, reject) => {
        itemsGroupEmp().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditGroupUserItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        groupUserItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditChangeAuditAuth ({ commit }, data) {
      return new Promise((resolve, reject) => {
        changeAuditAuth(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditDeleteAuditAuth ({ commit }, data) {
      return new Promise((resolve, reject) => {
        deleteAuditAuth(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditCreateAuditAuth ({ commit }, data) {
      return new Promise((resolve, reject) => {
        createAuditAuth(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditThroughA ({ commit }, data) {
      return new Promise((resolve, reject) => {
        throughA(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditThroughB ({ commit }, data) {
      return new Promise((resolve, reject) => {
        throughB(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditRefusedA ({ commit }, data) {
      return new Promise((resolve, reject) => {
        refusedA(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TandeAuditRefusedB ({ commit }, data) {
      return new Promise((resolve, reject) => {
        refusedB(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default tandeAudit



// WEBPACK FOOTER //
// ./src/store/modules/tandeAudit.js